import { gql } from '@apollo/client';

export const ACCOUNT_DELETE = gql(`mutation DeleteUser($id: ID!, $reason: String) {
  deleteUser(_id: $id, reason: $reason) {
    _id
  }
}`);
